import { clearLoginDetails } from "../auth";

export const CLEAR_REDUX_STATE = {
  CLEAR_LOGIN_DETAILS: clearLoginDetails,
};
